"use client";
import Image from "next/image";
import React from "react";
import AnimatedText from "./AnimatedText";
import AnimatedBlock from "./AnimatedBlock";
import AnimatedGrid from "./AnimatedGrid";
import AnimatedLink from "./AnimatedLink";
import translations from "@/lib/translations";
import Squircle from "@/components/Squircle";
import Icon from '@/components/Icon';

export default function ServiceList({ services, lang }) {
	const filteredServices = services;

	return (
		<section>
			<div className="inner-section">
				<div className="row">
					<div className="col-12">
						<AnimatedGrid className="grid full-services">
							{filteredServices.map((service) => (
								<article key={service._id} className="service-card">
									<Squircle size="box" />
									<div className="service-content">
										<div className="service-header">
											{service.icon && (
												<AnimatedBlock className="service-icon">
													<div className="icon-wrapper">
														<Image src={service.icon} alt="" width={150} height={150} className="icon" />
													</div>
												</AnimatedBlock>
											)}
											<AnimatedText variant="bounce" className="service-title">
												<h2>{service.title}</h2>
											</AnimatedText>
										</div>
										<AnimatedText variant="fade" className="service-description">
											{service.description?.map((block, i) => (
												<p key={block._key || i}>
													{block.children?.map((span, j) => {
														let content = span.text;
														const marks = span.marks || [];

														return marks.reduce((acc, mark) => {
															if (mark === "strong") return <strong key={j}>{acc}</strong>;
															if (mark === "em") return <em key={j}>{acc}</em>;
															const markDef = block.markDefs?.find((m) => m._key === mark);
															if (markDef?.href)
																return (
																	<a key={j} href={markDef.href} target="_blank" rel="noopener noreferrer">
																		{acc}
																	</a>
																);
															return acc;
														}, content);
													})}
												</p>
											))}
										</AnimatedText>
										{service.terms && service.terms.length > 0 && (
											<AnimatedText variant="fade">
												<ul className="service-terms">
													{service.terms.map((term, index) => (
														<li key={index}>{term}</li>
													))}
												</ul>
											</AnimatedText>
										)}
									</div>
									{service.project?.slug && (
										<div className="service-project">
											<AnimatedBlock className="icon label-wrapper">
												<div className="label">
													<svg viewBox="0 0 151 151" fill="none" xmlns="http://www.w3.org/2000/svg">
														<path d="M75.0449 0.0449219L80.3998 7.00532L86.7775 0.9683L90.9776 8.68068L98.2212 3.71568L101.163 11.9901L109.094 8.21943L110.705 16.8522L119.129 14.3686L119.37 23.1472L128.078 22.0119L126.943 30.7201L135.721 30.961L133.238 39.3844L141.87 40.9956L138.1 48.9268L146.374 51.8686L141.409 59.1123L149.122 63.3123L143.085 69.6901L150.045 75.0449L143.085 80.3998L149.122 86.7775L141.409 90.9776L146.374 98.2212L138.1 101.163L141.87 109.094L133.238 110.705L135.721 119.129L126.943 119.37L128.078 128.078L119.37 126.943L119.129 135.721L110.705 133.238L109.094 141.87L101.163 138.1L98.2212 146.374L90.9776 141.409L86.7775 149.122L80.3998 143.085L75.0449 150.045L69.6901 143.085L63.3123 149.122L59.1123 141.409L51.8686 146.374L48.9268 138.1L40.9956 141.87L39.3844 133.238L30.961 135.721L30.7201 126.943L22.0119 128.078L23.1472 119.37L14.3686 119.129L16.8522 110.705L8.21943 109.094L11.9901 101.163L3.71568 98.2212L8.68068 90.9776L0.9683 86.7775L7.00532 80.3998L0.0449219 75.0449L7.00532 69.6901L0.9683 63.3123L8.68068 59.1123L3.71568 51.8686L11.9901 48.9268L8.21943 40.9956L16.8522 39.3844L14.3686 30.961L23.1472 30.7201L22.0119 22.0119L30.7201 23.1472L30.961 14.3686L39.3844 16.8522L40.9956 8.21943L48.9268 11.9901L51.8686 3.71568L59.1123 8.68068L63.3123 0.9683L69.6901 7.00532L75.0449 0.0449219Z" />
													</svg>
													<span>{translations.featured[lang]}</span>
												</div>
											</AnimatedBlock>
											<AnimatedLink href={`/${lang}/work/${service.project.slug_shared}`}>
												<div className="project">
													<div className="thumbnail"><Squircle size="inner-card"></Squircle>{service.project?.thumbnail?.asset?.url && <img src={service.project.thumbnail.asset.url} alt="" className="thumb" loading="lazy" />}</div>
													<div className="infos">
														<AnimatedText variant="bounce">
															<h4 className="title">{service.project?.title}<Icon name="arrow-right" className="word bounce"/></h4>
														</AnimatedText>
													</div>
												</div>
											</AnimatedLink>
										</div>
									)}
								</article>
							))}
						</AnimatedGrid>
					</div>
				</div>
			</div>
		</section>
	);
}
